// This module provides API call methods for Sephora Commerce
// Utility Store Locator API:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Store+Locator+API

const getStoreLocations = require('./getStoreLocations');

module.exports = {
    getStoreLocations
};
